/**
 * Training slider with image:
 * - Desktop (≥768px): cellAlign center — 50%-wide cells, ½ + full + ½ peek.
 * - Mobile (<768px): cellAlign left — two cards per viewport (CSS slide width).
 * - groupCells: false for both.
 */
(function () {
  function getSmallBreakpoint() {
    return window.theme && window.theme.sizes && window.theme.sizes.small != null ? window.theme.sizes.small : 768;
  }

  function patchTrainingSlider(slider) {
    if (!slider) return;
    var flkty = window.theme && window.theme.Flickity && window.theme.Flickity.data(slider);
    if (!flkty || !flkty.isActive) return;

    var align = window.innerWidth < getSmallBreakpoint() ? 'left' : 'center';
    var changed = false;
    if (flkty.options.cellAlign !== align) {
      flkty.options.cellAlign = align;
      changed = true;
    }
    if (flkty.options.groupCells !== false) {
      flkty.options.groupCells = false;
      changed = true;
    }
    if (!changed) return;

    if (typeof flkty.reloadCells === 'function') {
      flkty.reloadCells();
    }
    flkty.resize();
  }

  function scan() {
    document.querySelectorAll('.training-slider-with-image grid-slider.flickity-enabled').forEach(patchTrainingSlider);
  }

  document.addEventListener('theme:slider:resize', function (e) {
    var slider = e.target && e.target.closest && e.target.closest('grid-slider.training-slider-with-image__carousel');
    if (slider) patchTrainingSlider(slider);
  });

  document.addEventListener('theme:resize:width', function () {
    scan();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.training-slider-with-image__carousel')) {
      setTimeout(scan, 50);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      var n = 0;
      var id = setInterval(function () {
        scan();
        n += 1;
        if (n >= 25) clearInterval(id);
      }, 120);
    });
  } else {
    var n = 0;
    var id = setInterval(function () {
      scan();
      n += 1;
      if (n >= 25) clearInterval(id);
    }, 120);
  }
})();
